import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoWhite from '../../assets/logo white.png';
import LogoBlack from '../../assets/logo black.jpg';
import { useTheme } from '../../context/ThemeContext';
import './OnboardingIntent.css';

const OnboardingIntent = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const Logo = theme === 'dark' ? LogoWhite : LogoBlack;

  const [selectedIntent, setSelectedIntent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const options = [
    {
      id: 'find_service',
      title: 'Find a Service Provider',
      description: 'Search & book trusted electricians, plumbers, cleaners, technicians, and more.',
      icon: 'fa-wrench',
      badge: 'Client',
      colorClass: 'option-service',
      modalMessage: 'Log in to your account to search, filter, and book verified service providers near you.',
    },
    {
      id: 'find_house',
      title: 'Find a House / Property',
      description: 'Browse apartments, family houses, guest houses, and land to rent or buy.',
      icon: 'fa-home',
      badge: 'Client',
      colorClass: 'option-house',
      modalMessage: 'Log in to your account to explore properties and homes for rent or sale across Cameroon.',
    },
    {
      id: 'become_service_provider',
      title: 'Become a Service Provider',
      description: 'Register your skills or business, offer your services, and receive customer bookings.',
      icon: 'fa-user-md',
      badge: 'Provider',
      colorClass: 'option-provider',
      modalMessage: 'Log in to your account to fill out and submit your service provider application.',
    },
    {
      id: 'become_property_owner',
      title: 'List your property',
      description: 'Rent out or sell your apartment, house or land on Spotfli. No application needed: verify your identity with your first listing.',
      icon: 'fa-building',
      badge: 'Agent / Landlord',
      colorClass: 'option-owner',
      modalMessage: 'Log in to your account to create your first listing.',
    },
  ];

  const handleSelectOption = (option) => {
    setSelectedIntent(option);
    localStorage.setItem('onboarding_intent', option.id);
    setShowModal(true);
  };

  const handleProceedToLogin = () => {
    if (!selectedIntent) return;
    navigate('/login', {
      state: { intent: selectedIntent.id }
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="onboarding-container">
      <div className="onboarding-background">
        <div className="onboarding-blob blob-1" />
        <div className="onboarding-blob blob-2" />
      </div>

      <div className="onboarding-content">
        <div className="onboarding-header">
          <img src={Logo} alt="Spotfli Logo" className="onboarding-logo" />
          <h1 className="onboarding-title">Why Are You Here Today?</h1>
          <p className="onboarding-subtitle">
            Welcome to Spotfli! Tell us what you would like to do so we can tailor your experience.
          </p>
        </div>

        <div className="onboarding-grid">
          {options.map((opt) => (
            <div
              key={opt.id}
              className={`onboarding-card ${opt.colorClass}`}
              onClick={() => handleSelectOption(opt)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') handleSelectOption(opt); }}
            >
              <div className="card-top">
                <div className="card-icon-wrapper">
                  <i className={`fa ${opt.icon}`} aria-hidden="true" />
                </div>
                <span className="card-badge">{opt.badge}</span>
              </div>

              <h2 className="card-title">{opt.title}</h2>
              <p className="card-desc">{opt.description}</p>

              <div className="card-action-bar">
                <span>Select & Proceed</span>
                <i className="fa fa-arrow-right" aria-hidden="true" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Login Prompt Modal */}
      {showModal && selectedIntent && (
        <div className="intent-modal-overlay" onClick={handleCloseModal}>
          <div className="intent-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="intent-modal-close" onClick={handleCloseModal} aria-label="Close modal">
              <i className="fa fa-times" aria-hidden="true" />
            </button>

            <div className="intent-modal-icon">
              <i className={`fa ${selectedIntent.icon}`} aria-hidden="true" />
            </div>

            <h2 className="intent-modal-title">Log In to Proceed</h2>
            <p className="intent-modal-subtitle">{selectedIntent.modalMessage}</p>

            <div className="intent-modal-actions">
              <button className="intent-modal-btn-login" onClick={handleProceedToLogin}>
                <i className="fa fa-sign-in" aria-hidden="true" />
                Log in to Proceed
              </button>
              <button className="intent-modal-btn-cancel" onClick={handleCloseModal}>
                Change Selection
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OnboardingIntent;
